<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Create a new Coordinator</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3>
        <form action="" @submit.prevent="onCreateCoordinator">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="coordinatorName"
              label="Name"
              v-model="coordinatorName"
              id="coordinatorName"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="coordinatorPhone"
              label="Phone Number"
              v-model="coordinatorPhone"
              id="coordinatorPhone"
              single-line
            ></v-text-field>
            <v-text-field
              name="coordinatorEmail"
              label="Email Address"
              v-model="coordinatorEmail"
              id="coordinatorEmail"
              single-line
              required
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn 
              class="primary" 
              :disabled="!formIsValid"
              type="submit">
                Create Coordinator
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      coordinatorName: '',
      coordinatorPhone: '',
      coordinatorEmail: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    coordinator () {
      return this.$store.getters.loadedCoordinator(this.id)
    },
    coordinators () {
      return this.$store.getters.loadedCoordinators
    },
    formIsValid () {
      return this.coordinatorName !== ''
    }
  },
  methods: {
    onCreateCoordinator () {
      if (!this.formIsValid) {
        return
      }
      const coordinatorData = {
        title: this.coordinatorName,
        coordinatorPhone: this.coordinatorPhone,
        coordinatorEmail: this.coordinatorEmail
      }
      this.$store.dispatch('createCoordinator', coordinatorData)
      this.$router.push('/coordinators')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateCoordinator.vue?59ffec31